/**
 * @generated SignedSource<<a8b13eaf3864b4b880a34f32de497154>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateActivityCriteriaInput = {
  activityIds?: ReadonlyArray<any | null | undefined> | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type useActivityCriteriaMutation$variables = {
  input: UpdateActivityCriteriaInput;
};
export type useActivityCriteriaMutation$data = {
  readonly updateActivityCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useActivityCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useActivityCriteriaMutation = {
  response: useActivityCriteriaMutation$data;
  variables: useActivityCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useActivityCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateActivityCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateActivityCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useActivityCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useActivityCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateActivityCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateActivityCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "ActivityCriterionConnection",
                    "kind": "LinkedField",
                    "name": "activityCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActivityCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activityId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "activityCriteria(orderBy:[\"ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f7a3a16d6d43c320cea40cb1c1ecb162",
    "id": null,
    "metadata": {},
    "name": "useActivityCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useActivityCriteriaMutation(\n  $input: UpdateActivityCriteriaInput!\n) {\n  updateActivityCriteria(input: $input) {\n    query {\n      ...useActivityCriteria_query\n      id\n    }\n  }\n}\n\nfragment useActivityCriteria_query on Query {\n  currentUser {\n    activityCriteria(orderBy: [ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC]) {\n      nodes {\n        activityId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e8755ff0db6db306a0a184ae7b325a6";

export default node;
